<template>
    <section>
        <nav class="nav pf df">
            <router-link to="/" exact class="item">首页</router-link>
            <router-link to="/videos" :class="`item${$route.name === 'homeVideo' ? ' router-link-active' : ''}`">视频</router-link>
            <router-link to="/contests" class="item">赛事</router-link>
            <router-link to="/studios" class="item">工作室</router-link>
            <router-link to="/dancers" class="item">舞者</router-link>
            <router-link to="/info" class="item">资讯</router-link>
            <div class="nav-line"></div>
        </nav>
        <nav class="nav-empty"></nav>
        <div v-show="show" class="open-app df ac">
            <i @touchend.prevent="show = false" class="icon-close"></i>
            <img class="logo" src="https://img.vhiphop.com/web/logo-icon.jpg" alt="">
            <div>
                <div class="title">上Vhiphop客户端</div>
                <div class="digest">高清视频 顶尖舞者动态一览无余</div>
            </div>
            <a class="download-btn df jcc ac pa" href="itms-apps://itunes.apple.com/app/id1104900956">立即体验</a>
        </div>
        <router-view></router-view>
    </section>
</template>

<script>
    export default {
        data: () => ({
            show: true,
        }),
    }
</script>

<style scoped>
    @import '../../../static/css/home/nav.css';
</style>



// WEBPACK FOOTER //
// src/components/home/Nav.vue